var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStroller(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5596 16.7939C16.5596 18.6268 15.4318 20.1133 14.04 20.1133H3.95996C2.56842 20.1129 1.44043 18.6267 1.44043 16.7939V12.5273H16.5596V16.7939ZM11.1602 16.3203C10.9616 16.3206 10.7999 16.5324 10.7998 16.7939C10.7998 17.0556 10.9615 17.2682 11.1602 17.2686H14.04C14.2388 17.2685 14.4004 17.0558 14.4004 16.7939C14.4003 16.5323 14.2388 16.3203 14.04 16.3203H11.1602ZM16.5605 9.68262V11.5791H1.44043V9.68262H16.5605ZM14.04 4.94141C15.4317 4.94143 16.5594 6.42706 16.5596 8.25977V8.73438H1.44043V8.25977C1.44061 6.42725 2.56853 4.94174 3.95996 4.94141H14.04Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroller);
export default __webpack_public_path__ + "static/media/Stroller.14995ee88e5d6ee27f94deed77e05586.svg";
export { ForwardRef as ReactComponent };